import { Component } from '@angular/core';
import { UILensService } from 'app/ui/lens/lens.service';
import { UserSettingsService } from 'app/user/user-settings.service';

@Component({
  selector: 'welcome-upload',
  templateUrl: 'upload.component.html',
  styleUrls: ['upload.component.scss']
})
export class WelcomeUploadComponent {

  constructor(private _uiLensService: UILensService, private _userSettings: UserSettingsService) {

  }

  ok(): void {
    this._userSettings.welcomeTraining = true;
    this._uiLensService.close();
  }
}
